import styled, { css } from 'styled-components';
import { jsx } from 'react/jsx-runtime';
import mq from '../../utils/mediaQueries.js';

var Wrapper = styled.div.withConfig({
  displayName: "ModalBleed__Wrapper",
  componentId: "sc-1n0rn8m-0"
})(["margin-inline:calc(var(--space-400) * -1);", ""], mq.s(css(["margin-inline:calc(var(--space-700) * -1);"])));
var ModalBleed = function ModalBleed(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/jsx(Wrapper, {
    children: children
  });
};
var ModalBleed$1 = ModalBleed;

export { ModalBleed$1 as default };
//# sourceMappingURL=ModalBleed.js.map
